<div class="flex flex-row flex-wrap justify-start items-center">
  <div class="joint-button-container flex flex-row justify-start items-center"
       *ngFor="let role of item.cells[fieldDefinition.key]?.value">
    <a class="pointer" (click)="updateUserRole(item)">{{role}}</a>
  </div>
</div>
